export default __webpack_public_path__ + "static/media/new_gif.6cac7e84.gif";